import * as React from 'react';
import { PasswordGate } from './src/components/password-gate';

export const wrapPageElement = ({ element }) => (
  <PasswordGate>{element}</PasswordGate>
);
